import { render } from "./VueHeader.vue?vue&type=template&id=34c7ab5a&scoped=true"
import script from "./VueHeader.vue?vue&type=script&lang=js"
export * from "./VueHeader.vue?vue&type=script&lang=js"

import "./VueHeader.vue?vue&type=style&index=0&id=34c7ab5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c7ab5a"]])

export default __exports__